import { ref, watchEffect, unref } from '@vue/composition-api'
import { storeToRefs } from 'pinia'
import TicketCategoriaStatusChipEnum from '@/models/entities/ticket/TicketCategoriaStatusChipEnum'
import TicketService from '@/services/modules/TicketService'
import useAtendimentoStore from '@/store/atendimento'
import useUserStore from '@/store/user'
import { EventBus } from '@/utils/EventBus'

export default function useListagemTickets(isGestor, filaId, protocolo) {
  const { id } = storeToRefs(useUserStore())

  const paginaAtual = ref(1)
  const numeroDePaginas = ref(0)
  const itensPorPagina = 8

  const tickets = ref([])
  const isGetTicketsLoading = ref(false)

  const filtroEmail = ref(null)
  const filtroProtocolo = ref(unref(protocolo))
  const filtroCategoriaListagem = ref(TicketCategoriaStatusChipEnum.Ativos)
  const filtroAgenteSelecionado = ref(0)
  const filtroSlaTipoId = ref(null)
  const filtroSlaTipoAlertaId = ref(null)

  const store = useAtendimentoStore()
  const { setIsLoading, setTicketSelecionadoId } = store
  watchEffect(() => { setIsLoading(isGetTicketsLoading.value) })

  let getTickets = async () => {}

  async function getTicketsFila() {
    try {
      const atendenteId = unref(isGestor) ? filtroAgenteSelecionado.value : id.value

      isGetTicketsLoading.value = true

      const data = await TicketService.getTickets(filaId, paginaAtual.value, itensPorPagina, atendenteId, filtroEmail.value, filtroProtocolo.value, filtroCategoriaListagem.value, filtroSlaTipoId.value, filtroSlaTipoAlertaId.value)

      tickets.value = data.items
      numeroDePaginas.value = data.totalPages
    } catch {
      tickets.value = []
      numeroDePaginas.value = 0
    } finally {
      isGetTicketsLoading.value = false
    }
  }

  async function getTicketsFilasAgrupadas() {
    try {
      const atendenteId = unref(isGestor) ? filtroAgenteSelecionado.value : id.value

      isGetTicketsLoading.value = true

      const data = await TicketService.getTicketsFilasAgrupadas(paginaAtual.value, itensPorPagina, atendenteId, filtroEmail.value, filtroProtocolo.value, filtroCategoriaListagem.value, filtroSlaTipoId.value, filtroSlaTipoAlertaId.value)

      tickets.value = data.items
      numeroDePaginas.value = data.totalPages
    } catch {
      tickets.value = []
      numeroDePaginas.value = 0
    } finally {
      isGetTicketsLoading.value = false
    }
  }

  if (filaId) {
    getTickets = getTicketsFila
  } else {
    getTickets = getTicketsFilasAgrupadas
  }

  async function getTicketsAndSelectFirst() {
    await getTickets()
    setTicketSelecionadoId(tickets.value.length ? tickets.value[0].id : 0)
  }

  EventBus.$on('fetch-tickets', getTickets)

  return {
    paginaAtual,
    numeroDePaginas,
    tickets,
    filtroEmail,
    filtroProtocolo,
    filtroCategoriaListagem,
    filtroAgenteSelecionado,
    filtroSlaTipoId,
    filtroSlaTipoAlertaId,
    getTickets,
    getTicketsAndSelectFirst,
  }
}
